import React, { useState } from 'react';
import Select from 'react-select';
import stylez from './SearctStrip.module.css';


const SearchStrip = ({setPage, searchCriteria, setSearchCriteria,setStateChanged,clearFilters,setClearFilters,setPageSize,pageSize}) => {
  const [runId, setRunId] = useState('');
  const [fromDate, setFromDate] = useState('');
  const [toDate, setToDate] = useState('');
  const [size,setSize] = useState(20);

  const handlePageSize=(e)=>{
        
    setSize(e.target.value);
  }
  const handlePageSizeClick =()=>{
    setPageSize(size);
  }


  const handleSearch = () => {
    // Trigger the search with the provided values
    // onSearch(searchCriteria);
    setPage(1);
    if (fromDate) {
      setSearchCriteria((data) => ({ ...data, fromDate: fromDate }));
    }
    if (runId) {
      setSearchCriteria((data) => ({ ...data, runId: runId }));
    }
    if (toDate) {
      setSearchCriteria((data) => ({ ...data, toDate: toDate }));
    }
    setClearFilters(true);
    setStateChanged(prevValue =>!prevValue);

  };

  const filterHandler = (btnAction) => {
    if (btnAction === 'date') {
      setSearchCriteria((preValue) => ({ ...preValue, fromDate: '', toDate: '' }));
      setFromDate('');
      setToDate('');
    }
    if (btnAction === 'runId') {
      setSearchCriteria((preValue) => ({ ...preValue, runId: '' }));
      setRunId('');
    }
    setPage(1);
    setStateChanged((prevValue) => !prevValue);
  };
  

  return (
    <div className={stylez.searchStripContainer}>
    <div  className={stylez.searchStrip}>
      <label>Run Id</label>
      <input
        type="text"
        value={runId}
        onChange={(e) => setRunId(e.target.value)}
      />
      <label>Search From Date</label>
      <input
        type="Date"
        value={fromDate}
        onChange={(e) => setFromDate(e.target.value)}
      />
      <label>To Date</label>
      <input
        type="Date"
        value={toDate}
        onChange={(e) => setToDate(e.target.value)} 
      />
      <button className="searchBtn" onClick={handleSearch}>Search</button>

      {clearFilters && (
          <div>
            {searchCriteria.fromDate && searchCriteria.toDate && (
              <span
                className='searchSpan'
                style={{ marginRight: '15px', marginLeft: '5px' }}
              >
                {searchCriteria.fromDate} - {searchCriteria.toDate}
                <button
                  className='spanBtn'
                  onClick={() => filterHandler('date')}
                >
                  {' '}
                  &times;
                </button>
              </span>
            )}
            {searchCriteria.runId && (
              <span className='searchSpan'>
                   Run Id : {searchCriteria.runId}
          
                <button
                  className='spanBtn'
                  onClick={() => filterHandler('runId')}
                >
                  &times;
                </button>
              </span>
            )}
          </div>
        )}
    </div>
    <div className={stylez.searchStrip}>
      <label>
       Number of entries per Page
      </label>
      <select onChange={handlePageSize} value={size}>
  <option value={20}>20 (default)</option>
  <option value={50}>50</option>
  <option value={100}>100</option>
</select>
      <button  onClick={handlePageSizeClick} style={{backgroundColor:'#007bff',color:'white',marginLeft:'10px',padding:'10px 16px'}}>Set</button>
      <label>Current Entries Per Page: {pageSize}</label>
       
    </div>

    </div>
  );
};

export default SearchStrip;
